import { apiClient } from "~/api/ApiClient";
import { PAGE_TITLES } from "~/configs/pageTitles";

import ExportsPage from "../ExportsPage/ExportsPage";

const KeywordRankingReports = () => (
  <ExportsPage
    exportType="KeywordExport"
    createFn={(siteId) => apiClient.sites.keywordExportsCreate(siteId)}
    pageTitle={PAGE_TITLES.keywordRankingReports}
    description="Use this page to create and download spreadsheet files of the keywords and rankings for your site."
    successMessage="Keyword ranking report is generating"
    emptyText="Create your first keyword ranking report to get started."
  />
);

export default KeywordRankingReports;
